<template>
	<div class="largeScreen">
		<el-button type="primary" plain class="backClass" @click="backClick()">返回</el-button>
		<div class="headerBox2">
			大屏幕列表
			<el-button type="primary" plain class="addButtonClass" @click="addClick()">新建大屏幕</el-button>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" style="width: 100%" v-loading="loading">
				<el-table-column prop="name" label="大屏幕名称" min-width="1%">
				</el-table-column>
				<el-table-column prop="" label="logo标志" min-width="1%">
				</el-table-column>
				<el-table-column prop="address" label="操作" min-width="1%">
					<template slot-scope="scope">
						<a class="editClass" @click.prevent="editClick(scope.row.id,scope.row)">编辑</a>
						<a class="editClass" @click.prevent="detailClick(scope.row.id,scope.row,scope.row.name)">查看</a>
						<a class="editClass" @click.prevent="deleteClick(scope.row.id,scope.row.code)">删除</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!--弹窗-->
		<el-dialog :title="title" :visible.sync="dialogFormVisible" :width="dialogWidth" :close-on-click-modal="false">
			<div>11111</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="save()" class="confrim" type="primary">立即创建</el-button>
				<el-button @click="dialogFormVisible=false" class="cancle">取消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'Vuex';
	import headers from '../../../static/js/headers.js'
	import dataList from '../../../static/js/dataList.js'
	import md5 from '../../../static/js/md5.js'
	import qs from 'qs'
	import axios from 'axios'
	export default {
		mounted() {
			this.b_id = this.$route.query.b_id
			this.category_id = this.$route.query.category_id
			this.firstPageIndex = this.$route.query.fI
			this.secondPageIndex = this.$route.query.sI
			window.addEventListener('resize', () => {
				if(document.body.clientWidth < 767) {
					this.dialogWidth = "100%"
				} else if(document.body.clientWidth < 1200) {
					this.dialogWidth = "80%"
				} else {
					this.dialogWidth = "55%"
				}
			})
		},
		created() {
			if(document.body.clientWidth < 767) {
				this.dialogWidth = "100%"
			} else if(document.body.clientWidth < 1200) {
				this.dialogWidth = "80%"
			} else {
				this.dialogWidth = "55%"
			}
		},
		computed: {
			...mapGetters(['http'])
		},
		data() {
			return {
				loading: false, //加载状态
				clientHeight: '', //滚动高度
				pageSize: 20, //每页条数
				firstPageIndex: '', //第一个页面的当前页
				pageIndex: 1, //当前页
				total: 0, //总条数
				tableData: [{
					'name': '6666',
				}],
				title: '', //弹窗标题
				product_id: '', //产品id
				category_id: '', //分类id
				productList: [], //产品列表
				dialogFormVisible: false,
				firstPageIndex: '', //第一个页面的当前页
				secondPageIndex: '', //第二个页面的当前页
				b_id: ''
			}
		},
		methods: {
			detailClick() {
				this.$router.push({
					path: '/customer/largeScreenDetail',
					name: 'LargeScreenDetail',
					query: {
						c_id: this.$route.query.c_id,
						name: this.$route.query.name,
						b_id: this.$route.query.b_id,
						sI: this.$route.query.sI,
					}
				})
			},
			backClick() {
				this.$router.push({
					path: '/customer/customerDetail',
					name: 'CustomerDetail',
					query: {
						id: this.b_id,
						sI: this.secondPageIndex,
						fI: this.firstPageIndex
					}
				})
			}
		}
	}
</script>

<style>
	.largeScreen {
		/*height: 612px;*/
		overflow: auto;
		/*height: 100%;*/
		padding: 0 12% 0 12%;
		position: relative;
	}
	
	.largeScreen .backClass {
		margin-top: 3.2%;
		padding: 8px 22px;
		font-size: 13px;
		margin-bottom: 24px;
	}
	
	.largeScreen .addButtonClass {
		position: absolute;
		top: 4px;
		right: 1%;
		width: 100px;
		padding: 8px 22px;
		font-size: 13px;
	}
	
	.largeScreen .headerBox2 {
		position: relative;
		height: 26px;
		line-height: 26px;
		padding: 6px 20px;
		padding-left: 10px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
		font-size: 13px;
		margin: 0 10px 10px 10px;
	}
	
	.largeScreen .tableBox {
		padding: 0 20px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
		margin-bottom: 45px;
	}
	/*表格*/
	
	.largeScreen .el-table th {
		color: #000;
	}
	
	.largeScreen .el-table {
		font-size: 12px;
	}
	
	.largeScreen .el-table th,
	.largeScreen .el-table td,
	.largeScreen .el-table tr {
		background-color: #FFF;
		padding: 6px 0!important;
		text-align: left;
	}
	
	.largeScreen .el-table th {
		padding: 10px 0!important;
		font-weight: 400;
		text-align: left;
		color: #999;
	}
	
	.largeScreen .editClass {
		color: #439DFD;
		margin-right: 30px;
		cursor: pointer;
	}
	/*弹窗*/
	
	.largeScreen .el-dialog__title {
		color: #999;
	}
	
	.largeScreen .el-dialog__footer {
		text-align: center;
	}
	
	.largeScreen .pagination {
		text-align: center;
	}
	
	.largeScreen .pagination .el-input__inner {
		height: 30px;
		line-height: 30px;
	}
	
	.largeScreen .specilDialog .el-dialog__header {
		border-bottom: 1px solid #ebebeb;
	}
</style>


// WEBPACK FOOTER //
// src/components/Customer/LargeScreen.vue